import React, {createContext, useEffect, useMemo, useState} from 'react';
import {AppProvider as PolarisAppProvider} from '@shopify/polaris';
import {AppBridgeState, ClientApplication, createApp} from '@shopify/app-bridge';
import en from '@shopify/polaris/locales/en.json';
import RecommendationsPage from './pages/RecommendationsPage/RecommendationsPage';
import AuthGate from './components/AuthGate/AuthGate';
import reportWebVitals from "./reportWebVitals";

export const AppBridgeContext = createContext<ClientApplication<AppBridgeState> | null>(null);

export const API_KEY = process.env.REACT_APP_SHOPIFY_API_KEY || 'SHOPIFY_API_KEY';

export default function App() {
    const [isAuthed, setIsAuthed] = useState(false);
    const [missingHost, setMissingHost] = useState(false);

    const searchParams = new URLSearchParams(window.location.search);
    const shop = searchParams.get('shop');
    const host = searchParams.get('host');
    const shopifyAdminAppsUrl = `https://admin.shopify.com/store/${shop}/apps`;

    // Create an instance of App Bridge
    const appBridge = useMemo(() => {
        if (!host) return null;
        return createApp({
            apiKey: API_KEY,
            host,
            forceRedirect: true, // ensures app embeds correctly after auth
        });
    }, [host]);

    useEffect(() => {
        setMissingHost(!host);
    }, [host]);

    if (missingHost) {
        return (
            <div style={{ padding: 32 }}>
                <p>
                    Missing <code>host</code> parameter.<br />
                    Please launch this app from <b>Shopify Admin</b>.<br />
                    <a href={shopifyAdminAppsUrl}>
                        Click here to open Shopify Admin
                    </a>
                </p>
            </div>
        );
    }

    if (!appBridge) return null;

    reportWebVitals(console.log); // Call reportWebVitals

    return (
        <PolarisAppProvider i18n={en}>
            <AppBridgeContext.Provider value={appBridge}>
                {!isAuthed ? (
                    <AuthGate onAuthSuccess={() => setIsAuthed(true)} appBridge={appBridge} />
                ) : (
                    <RecommendationsPage />
                )}
            </AppBridgeContext.Provider>
        </PolarisAppProvider>
    );
}
